// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","follow":"qcF5y1Tr m0","follow-label":"k_17wRui","followLabel":"k_17wRui","icon":"HDuKM4iC"};